import React from 'react';
import PropTypes from 'prop-types';

import Button from './Button';
import Loader from './Loader';

import { BorderRadius, FontSizes, FontWeights } from '../Theme';

const Card = ({ buttons, children, contentPadding, footer, loading, style, title }) => {
  const styles = {
    component: Object.assign(
      {},
      {
        border: '1px solid #ccc',
        borderRadius: BorderRadius.DEFAULT,
        background: '#fff',
        boxShadow: '0px 2px 5px rgba(0,0,0,0.1)'
      },
      style
    ),
    header: {
      padding: 20,
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid #ccc'
    },
    title: {
      fontSize: FontSizes.REGULAR,
      fontWeight: FontWeights.MEDIUM
    },
    buttons: {
      display: 'flex',
      marginLeft: 'auto'
    },
    content: {
      padding: contentPadding || 30
    },
    footer: {
      padding: '15px 20px',
      borderTop: '1px solid #ccc'
    }
  };

  return (
    <div style={styles.component}>
      {title || buttons ? (
        <div style={styles.header}>
          <div style={styles.title}>{title}</div>
          {buttons ? (
            <div style={styles.buttons}>
              {buttons.map((button, i) => {
                const multiple_btns = buttons.length > 1;
                const is_first = i === 0;
                const is_last = i === buttons.length - 1;
                const styles = Object.assign(
                  {},
                  multiple_btns && { borderRadius: 0, marginLeft: 1 },
                  multiple_btns && is_first && { borderRadius: '4px 0 0 4px' },
                  multiple_btns && is_last && { borderRadius: '0 4px 4px 0' }
                );

                return (
                  <Button {...button} key={i} small={true} style={styles}>
                    {button.label}
                  </Button>
                );
              })}
            </div>
          ) : null}
        </div>
      ) : null}
      <div style={styles.content}>{loading ? <Loader /> : children}</div>
      {footer ? <div style={styles.footer}>{footer}</div> : null}
    </div>
  );
};

Card.propTypes = {
  buttons: PropTypes.array,
  contentPadding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  footer: PropTypes.node,
  loading: PropTypes.bool,
  title: PropTypes.node
};

export default Card;
